import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Save } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function AdminSettings() {
  const [me, setMe] = useState(null);
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirmPw, setConfirmPw] = useState("");

  useEffect(() => {
    api.get("/admin/me").then((r) => setMe(r.data));
  }, []);

  const change = async () => {
    if (next.length < 10) return toast.error("Minimum 10 tekens");
    if (next !== confirmPw) return toast.error("Wachtwoorden komen niet overeen");
    try {
      await api.post("/admin/auth/change-password", {
        current_password: current,
        new_password: next,
      });
      toast.success("Wachtwoord aangepast");
      setCurrent(""); setNext(""); setConfirmPw("");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Mislukt");
    }
  };

  return (
    <div className="space-y-7 max-w-xl">
      <div>
        <h1 className="font-display font-bold text-oc-primary text-[34px]">Instellingen</h1>
        <p className="text-oc-textSecondary mt-1">Beheer je admin account.</p>
      </div>

      <div className="bg-white border border-oc-border rounded-oc p-7 space-y-2">
        <p className="text-[13px] uppercase tracking-[0.05em] font-semibold text-oc-textSecondary">Ingelogd als</p>
        <p className="font-display font-semibold text-oc-primary text-[18px]">{me?.email || "—"}</p>
      </div>

      <div className="bg-white border border-oc-border rounded-oc p-7 space-y-4">
        <h2 className="font-display font-semibold text-oc-primary text-[20px]">Wachtwoord wijzigen</h2>
        <div className="space-y-2">
          <Label>Huidig wachtwoord</Label>
          <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className="h-12 rounded-oc-btn" />
        </div>
        <div className="space-y-2">
          <Label>Nieuw wachtwoord</Label>
          <Input type="password" value={next} onChange={(e) => setNext(e.target.value)} className="h-12 rounded-oc-btn" />
        </div>
        <div className="space-y-2">
          <Label>Bevestig nieuw wachtwoord</Label>
          <Input type="password" value={confirmPw} onChange={(e) => setConfirmPw(e.target.value)} className="h-12 rounded-oc-btn" />
        </div>
        <Button onClick={change} className="bg-oc-primary hover:bg-oc-secondary text-white rounded-oc-btn h-12 px-7 font-semibold">
          <Save className="w-4 h-4 mr-2" /> Opslaan
        </Button>
      </div>
    </div>
  );
}
